import React from 'react';
import classNameBind from 'classnames/bind';
import { withTranslation } from '../Translator';
import styles from './ProgressBar.module.css';

const bindClasses = classNameBind.bind(styles);

const colors = {
  blue: '#107ef1', // vBlue
  orange: '#f57f09', // vOrange
  red: '#e3301b', // vRed
};

const getColorFromAppearance = (appearance, first, mainColor) => {
  switch (appearance) {
    case 'ratio':
      return first ? '#1aa023' : '#e3301b';
    case 'default':
    default:
      return first ? colors[mainColor] : '#eeeeee';
  }
};

const ProgressBar = ({
  progress,
  status,
  title,
  caption,
  sidenote,
  hideProgressNumber,
  dataId,
  t,
  appearance,
  mainColor,
}) => (
  <div className={bindClasses('wrapper')} data-ppuc-id={dataId}>
    {
      title || caption
        ? (
          <div className={bindClasses('title-container')}>
            <div className={bindClasses('title')} data-ppuc-id={`${dataId}.title`}>
              {title}
            </div>
            <div className={bindClasses('caption')} data-ppuc-id={`${dataId}.caption`}>
              {caption}
            </div>
          </div>
        ) : null
    }
    <div
      className={bindClasses('bar')}
      style={{
        backgroundColor: getColorFromAppearance(appearance, false, mainColor),
      }}
    >
      {progress >= 0 ? (
        <div
          style={{
            width: `${progress}%`,
            backgroundColor: getColorFromAppearance(appearance, true, mainColor),
          }}
        />
      ) : (
        <div
          className={bindClasses('endless')}
          style={{
            backgroundColor: getColorFromAppearance(appearance, true, mainColor),
          }}
        />
      )}
    </div>
    <div className={bindClasses('footer-container')}>
      <div
        className={bindClasses('status', appearance, appearance === 'default' ? mainColor : '')}
        data-ppuc-id={`${dataId}.status`}
      >
        {status && `${status} `}
        {!hideProgressNumber && progress >= 0 && `${t('number', { number: progress })}%`}
      </div>
      {
        sidenote
          ? (
            <div className={bindClasses('sidenote', appearance)} data-ppuc-id={`${dataId}.sidenote`}>
              {sidenote}
            </div>
          )
          : null
      }
    </div>
  </div>
);

ProgressBar.defaultProps = {
  progress: -1,
  status: '',
  title: '',
  caption: '',
  sidenote: '',
  hideProgressNumber: false,
  dataId: 'ProgressBar',
  appearance: 'default',
  mainColor: 'blue',
};

const withTranslate = withTranslation('components')(ProgressBar);
withTranslate.displayName = 'ProgressBar';

export default withTranslate;
export const PureComponent = ProgressBar;
